import {
  PublicGetCustomerTransactionResponse,
} from '@bukalapak/openapi-schema/vptrader/transaction/v2/public/transaction-domain';
import VPNonTraderAPIClient from '~/api/vpnontrader';

const initialState = {
  transaction: {},
  loading: true,
};

const getters = {
  getTravelTransaction(state) {
    return state.transaction;
  },
  getTravelTransactionLoading(state) {
    return state.loading;
  },
};

const actions = {
  async retrieveTravelTransaction({ dispatch, commit }, payload) {
    let response: PublicGetCustomerTransactionResponse = {};

    const { options, ...requestPayload } = payload;

    try {
      if (!options?.ignoreLoading) {
        commit('setTravelTransactionLoading', true);
      }

      response = await VPNonTraderAPIClient.getCustomerTransactionTravel(requestPayload.id);
      const transaction = response.customer_transaction;
      commit('setTravelTransaction', transaction);
      return transaction;
    } catch (error) {
      const message = 'Gagal mendapatkan data transaksi';
      dispatch('catchError', { error, message });
      throw error;
    } finally {
      commit('setTravelTransactionLoading', false);
    }
  },
};

const mutations = {
  setTravelTransaction(state, transaction) {
    state.transaction = transaction;
  },
  setTravelTransactionLoading(state, isLoading) {
    state.loading = isLoading;
  },

};

export default {
  state: () => ({ ...initialState }),
  mutations,
  getters,
  actions,
};
